import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import PictureAsPdf from '@material-ui/icons/PictureAsPdf';
import ImageIcon from '@material-ui/icons/Image';
import DescriptionIcon from '@material-ui/icons/Description';
import { isImageMime } from '../utils';

const useStyles = makeStyles({
  thumbnail: {
    width: 40,
    minWidth: 40,
    height: 40,
    minHeight: 40,
    maxHeight: 40,
    objectFit: 'cover',
    borderRadius: 6,
    border: '2px solid #fff',
    outline: '1px solid #e0e0e0',
    flexShrink: 0,
  },
  iconWrap: {
    width: 40,
    minWidth: 40,
    height: 40,
    borderRadius: 6,
    backgroundColor: '#fff',
    border: '1px solid #e0e0e0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#666',
    flexShrink: 0,
  },
});

const getIcon = (mimeType) => {
  if (!mimeType) return DescriptionIcon;
  if (mimeType === 'application/pdf') return PictureAsPdf;
  if (isImageMime(mimeType)) return ImageIcon;
  return DescriptionIcon;
};

const FileThumbnail = ({ mimeType, src }) => {
  const classes = useStyles();
  const [broken, setBroken] = React.useState(false);
  const isImage = isImageMime(mimeType);
  const Icon = getIcon(mimeType);

  React.useEffect(() => {
    setBroken(false);
  }, [src]);

  if (isImage && src && !broken) {
    return <img src={src} alt="" className={classes.thumbnail} onError={() => setBroken(true)} />;
  }

  return (
    <div className={classes.iconWrap}>
      <Icon />
    </div>
  );
};

FileThumbnail.propTypes = {
  mimeType: PropTypes.string,
  src: PropTypes.string,
};

export default FileThumbnail;
